import { useAuth } from "react-oidc-context";
import { Route, Routes, useLocation } from "react-router-dom";

import { Nav } from "./components/Nav";
import { Login } from "./pages/Login";
import { AuthCallback } from "./pages/AuthCallback";
import { Dashboard } from "./pages/Dashboard";
import { Settings } from "./pages/Settings";
import { Profile } from "./pages/Profile";
import { Inbox } from "./pages/Inbox";
import { JobDetail } from "./pages/JobDetail";
import { Runs } from "./pages/Runs";
import { Admin } from "./pages/Admin";
import { isAdmin } from "./auth";

export default function App() {
  const auth = useAuth();
  const location = useLocation();

  if (location.pathname === "/auth/callback") return <AuthCallback />;

  if (auth.isLoading) {
    return <CenteredMessage>Loading…</CenteredMessage>;
  }
  if (auth.error) {
    return <CenteredMessage>Authentication error: {auth.error.message}</CenteredMessage>;
  }
  if (!auth.isAuthenticated) {
    return <Login />;
  }

  const admin = isAdmin(auth.user?.profile);

  return (
    <div className="flex min-h-full flex-col">
      <Nav />
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/jobs/:jobId" element={<JobDetail />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/runs" element={<Runs />} />
          <Route
            path="/admin"
            element={admin ? <Admin /> : <CenteredMessage>403 — admin access required</CenteredMessage>}
          />
          <Route path="*" element={<CenteredMessage>404 — page not found</CenteredMessage>} />
        </Routes>
      </main>
    </div>
  );
}

function CenteredMessage({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-full items-center justify-center text-slate-300">
      {children}
    </div>
  );
}
